var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediumSeverity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.39,124.85l.08-.1c-21.79-.04-39.52,17.51-39.7,39.3l-.63,135c26.24-4.85,53.23-3.93,79.09,2.68l.64-137.36c-.05-21.79-17.68-39.45-39.47-39.52"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.97,128.67v51.33c9.79.54,19.44,2.08,28.81,4.57l.09-20.21c-.04-17.46-12.45-32.13-28.9-35.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.02,317.79h.05c-.06,2.76,2.14,5.04,4.9,5.1h87.1c2.7,0,4.91-2.14,5-4.83,1.08-33.5,13.95-65.55,36.33-90.51l-68.69-68.55c-40.45,43.11-63.5,99.68-64.69,158.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.97,83v39.56c19.77,3.64,34.85,21.02,34.9,41.81l-.1,21.94c19.33,6.05,37.27,16.18,52.55,29.88l68.59-68.59c-42.4-39.77-97.84-62.73-155.94-64.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.77,164.07l-.1,20.4c9.21-2.41,18.68-3.9,28.3-4.43v-51.31c-16.02,3.8-28.06,18.19-28.2,35.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.97,308.13c-33.36,0-60.4,27.04-60.4,60.4s27.04,60.4,60.4,60.4,60.4-27.04,60.4-60.4-27.04-60.4-60.4-60.4ZM245.97,333c0-4.42,3.58-8,8-8s8,3.58,8,8v37.79c0,4.42-3.58,8-8,8s-8-3.58-8-8v-37.79ZM253.97,404.18c-4.46,0-8.07-3.61-8.07-8.07s3.61-8.07,8.07-8.07,8.07,3.61,8.07,8.07-3.61,8.07-8.07,8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.24,158.95l-68.6,68.6c22.38,24.96,35.25,57.01,36.33,90.51.09,2.69,2.3,4.83,5,4.83h87.1c2.76-.06,4.96-2.34,4.9-5.1-1.19-59.13-24.25-115.72-64.73-158.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.77,164.04c.17-20.45,14.87-37.53,34.2-41.44v-39.59c-58.11,1.86-113.54,24.82-155.94,64.6l68.59,68.59c15.41-13.8,33.54-23.98,53.05-30l.1-22.15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumSeverity);
export default __webpack_public_path__ + "static/media/mediumSeverity.e1ffd3abbecb97fe63a49666f4e233ef.svg";
export { ForwardRef as ReactComponent };